import React from "react";
import { createGlobalStyle } from "styled-components";

const CSSInjector = ({ injectCSS }) => {
  const CSSInjection = createGlobalStyle`${injectCSS}`;
  return <CSSInjection />;
};

export default CSSInjector;
